define('controllers/home',['require','layout','rv!templates/about/home'],function (require) {
    'use strict';
    //TODO: handle p querystring as it gets handled in backend...or just skip it...I don't think it's used?
    var layout = require('layout');
    return {
        load: function (customerShortId, querystring) {
            this.ractive = layout.initRactive(window.ServerData, require('rv!templates/about/home'));
            this.mainslideshow = window.app.controllerManager.controllers.mainslideshow[0];
            this.mainslideshow.load(customerShortId, querystring);
        },

        unload: function () {
            if (this.ractive != null) { this.ractive.teardown(); }
            if (this.mainslideshow != null) { this.mainslideshow.unload(); }
        }
    };
});

